import styled from "styled-components";

export const MainCenter = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;
export const SecondContainer = styled.div`
  display: flex;
  @media (max-width: 1000px) {
    flex-direction: column;
  } ;
`;

export const ThirdContainer = styled.div`
  position: relative;
`;

export const ContainerHeadings = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 2rem;
  @media (max-width: 1000px) {
    margin-left: 0;
  } ;
`;
export const Bar = styled.div`
  border-left: 2px solid #e4e4e4;
  height: 320px;
  margin-left: 3rem;
  margin-top: -2rem;
  @media (max-width: 1000px) {
    display: none;
  } ;
`;

export const MainTitle = styled.p`
  font-family: Roboto;
  font-size: 50px;
  font-weight: bold;
  margin-bottom: 0;
  @media (max-width: 520px) {
    margin-top: 0px;
    font-size: 32px;
  }
`;
export const SecondTitle = styled.p`
  font-family: Raleway;
  font-size: 34px;
  @media (max-width: 520px) {
    font-size: 18px;
  }
`;
export const Btn = styled.svg`
  position: absolute;
  top: 140px;
  cursor: pointer;
  @media (max-width: 520px) {
    top: 70px;
  }
`;
export const Arrow = styled.svg`
  position: absolute;
  top: 150px;
  left: 10px;
  cursor: pointer;
  @media (max-width: 520px) {
    top: 80px;
  }
`;

interface TypeColor {
  color?: string;
}

export const GoToStart = styled.p<TypeColor>`
  margin-left: 50px;
  cursor: pointer;
  color: ${(props) => props.color};
`;
